let utils = {
    isNotNumber:function (item) {
        if(item == "" || item == null || item == undefined || isNaN(item)){
            return true;
        }else {
            return false;
        }
    },
    isEmpty:function (item) {
        if(item == "" || item == null || item == undefined){
            return true;
        }else {
            return false;
        }
    },
    unixtimeToDate: function(unixtime){
        let dateTime = new Date(unixtime);
        let year = 1900 + dateTime.getYear();
        let month = "0" + (dateTime.getMonth() + 1);
        let date = "0" + dateTime.getDate();
        let hour = "0" + dateTime.getHours();
        let minute = "0" + dateTime.getMinutes();
        let second = "0" + dateTime.getSeconds();
        return year + "-" + month.substring(month.length-2, month.length)  + "-" + date.substring(date.length-2, date.length)
            + " " + hour.substring(hour.length-2, hour.length) + ":"
            + minute.substring(minute.length-2, minute.length) + ":"
            + second.substring(second.length-2, second.length);
    },
    _mime: (option, value)=>{
        let mimeTypes = navigator.mimeTypes;
        for (let mt in mimeTypes) {
            if (mimeTypes[mt][option] == value) {
                return true;
            }
        }
        return false;
    }
};

export default{
    install(Vue,options)
    {
        Vue.prototype.utils = utils;
    }
}
